module.exports = __webpack_public_path__ + "img/Mage-undead-m-60.fdbf2f19.gif";